import { Container, Grid, Card, Box, Divider } from "@mui/material";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";
import PublicNavbar from "../../../devComponents/Navbars/PublicNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";
import footerRoutes from "footer.routes";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../Home/sections/Download";
import ConsultationForm from "../../ConsultationProgram/ConsultationForm";
import MedcoCaseStudy from "../../../assets/images/LandingPage/caseStudyMedcoPNG.png";
import M1 from "../../../assets/images/caseStudies/medco/medco1.png";
import M3 from "../../../assets/images/caseStudies/medco/medco3.png";
import M4 from "../../../assets/images/caseStudies/medco/medco4.png";
import M5 from "../../../assets/images/caseStudies/medco/medco5.png";
import M6 from "../../../assets/images/caseStudies/medco/medco6.png";
import M9 from "../../../assets/images/caseStudies/medco/medco9.png";
import M10 from "../../../assets/images/caseStudies/medco/medco10.png";

function MedCoCaseStudy() {
  const navigate = useNavigate();

  const [consultOpen, setConsultOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const videoUrls = [
    "https://firebasestorage.googleapis.com/v0/b/elagitherapy.appspot.com/o/LandingPageVideos%2Fvideo%205.mp4?alt=media&token=c42dbd59-5ab8-4b6f-a480-4eb5f5825ebe",
    "https://firebasestorage.googleapis.com/v0/b/elagitherapy.appspot.com/o/LandingPageVideos%2Fvideo%202.mp4?alt=media&token=2dcf2da5-548e-4fb7-a73d-664a808a6546",
    "https://firebasestorage.googleapis.com/v0/b/elagitherapy.appspot.com/o/LandingPageVideos%2Fvideo%207.mp4?alt=media&token=7d72c8de-c501-4910-bbc1-50ef14cd9d10",
    "https://firebasestorage.googleapis.com/v0/b/elagitherapy.appspot.com/o/LandingPageVideos%2Fvideo%204.mp4?alt=media&token=3baf8f87-7fc1-49ad-a533-943ef900e921",
    "https://firebasestorage.googleapis.com/v0/b/elagitherapy.appspot.com/o/LandingPageVideos%2Fvideo%201_1.mp4?alt=media&token=cb74201d-8afb-4bf6-89a1-960920200dc8",
    "https://firebasestorage.googleapis.com/v0/b/elagitherapy.appspot.com/o/LandingPageVideos%2Fvideo%206_1.mp4?alt=media&token=43cd0b45-6f87-46fd-a053-9854c9502852",
    "https://firebasestorage.googleapis.com/v0/b/elagitherapy.appspot.com/o/LandingPageVideos%2Fvideo%203.mp4?alt=media&token=d00649ab-0a98-4a62-8100-a9267f8cbfd8",
  ];

  return (
    <MKBox sx={{ background: "#f8f9fa" }}>
      <PublicNavbar />

      {/* Hero Section */}
      <MKBox
        minHeight="35vh"
        width="100%"
        sx={{
          background: "linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          pt: { xs: 15, md: 17 },
          mt: "-80px",
        }}
      >
        <Container>
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={6}>
              <MKTypography
                variant="h1"
                color="white"
                sx={{
                  fontWeight: 700,
                  fontSize: { xs: "2rem", md: "3rem" },
                  textShadow: "2px 4px 8px rgba(0,0,0,0.3)",
                  mb: 2,
                  textAlign: "center",
                }}
              >
                MedCo Case Study
              </MKTypography>
              <MKTypography
                variant="h4"
                color="white"
                sx={{
                  fontWeight: 600,
                  fontSize: { xs: "1.25rem", md: "1.75rem" },
                  textShadow: "1px 2px 4px rgba(0,0,0,0.2)",
                  opacity: 0.95,
                  mb: 3,
                  textAlign: "center",
                }}
              >
                Scaling a Physiotherapy Leader: The MedCo Implementation That
                Drove 5× Growth
              </MKTypography>
              <MKTypography
                variant="h6"
                color="white"
                sx={{
                  fontWeight: 400,
                  opacity: 0.9,
                  textShadow: "1px 2px 4px rgba(0,0,0,0.2)",
                  textAlign: "center",
                }}
              >
                Between 2022 and 2025, Elagi transformed its internal
                operations, achieving five times its previous operational
                capacity through centralized systems and improved workflow
                efficiency.
              </MKTypography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box
                component="img"
                src={MedcoCaseStudy}
                alt="MedCo"
                sx={{
                  width: "100%",
                  borderRadius: 4,
                }}
              />
            </Grid>
          </Grid>
        </Container>
      </MKBox>

      <Container sx={{ mt: { xs: 3, md: 6 }, mb: 10 }}>
        {/* Back Button */}
        <Box sx={{ mb: 4 }}>
          <MKButton
            variant="text"
            color="dark"
            onClick={() => navigate("/case-studies")}
            sx={{ pl: 0, color: "#0b1020", fontWeight: 600 }}
          >
            ← Back to Case Studies
          </MKButton>
        </Box>

        {/* Client Overview */}
        <Card
          sx={{
            p: { xs: 3, md: 6 },
            mb: 4,
            borderRadius: 4,
            boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
          }}
        >
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={8}>
              <MKTypography
                variant="h3"
                sx={{ fontWeight: 600, mb: 3, color: "#344767" }}
              >
                Client Overview
              </MKTypography>
              <MKTypography
                variant="body1"
                sx={{
                  color: "#7b809a",
                  lineHeight: 1.8,
                  fontSize: "1.1rem",
                  mb: 2,
                }}
              >
                Elagi is a well-established physiotherapy center known for its
                high patient volume and trusted reputation in its market. With a
                growing team of therapists and a busy daily schedule, Elagi
                operates in a fast-paced environment where efficiency,
                coordination, and accuracy are critical to patient care and
                business performance.
              </MKTypography>
              <MKTypography
                variant="body1"
                sx={{ color: "#7b809a", lineHeight: 1.8, fontSize: "1.1rem" }}
              >
                As the clinic expanded, managing daily operations using manual
                tools and disconnected systems became increasingly challenging.
                Elagi needed a centralized solution that could support their
                growth, reduce operational friction, and bring structure to
                their workflows without disrupting ongoing operations.
              </MKTypography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box
                component="img"
                src={M1}
                alt="Client overview"
                sx={{ width: "100%" }}
              />
            </Grid>
          </Grid>
        </Card>

        {/* Clinic Video Highlights */}
        <Card
          sx={{
            p: { xs: 3, md: 4 },
            mb: 4,
            borderRadius: 4,
            boxShadow: "0 8px 32px rgba(0,0,0,0.06)",
          }}
        >
          <MKTypography
            variant="h3"
            sx={{ fontWeight: 600, mb: 1, color: "#344767" }}
          >
            Testimonials
          </MKTypography>

          <Box
            sx={{
              display: "flex",
              overflowX: "auto",
              gap: 2,
              pb: 1,
              pl: 1,
              "&::-webkit-scrollbar": { height: 8 },
              "&::-webkit-scrollbar-thumb": {
                background: "rgba(0,0,0,0.15)",
                borderRadius: 2,
              },
            }}
          >
            {videoUrls.map((url, idx) => (
              <Box
                key={idx}
                sx={{
                  width: { xs: "100%", md: "27%" },
                  flex: "0 0 auto",
                  borderRadius: 2,
                  overflow: "hidden",
                  background: "#000",
                }}
              >
                <Box
                  component="video"
                  src={url}
                  controls
                  playsInline
                  preload="metadata"
                  sx={{
                    width: "100%",
                    height: { xs: 350, md: 460 },
                    objectFit: "cover",
                    display: "block",
                  }}
                />
              </Box>
            ))}
          </Box>
        </Card>

        {/* Challenges */}
        <Card
          sx={{
            p: { xs: 3, md: 6 },
            mb: 4,
            borderRadius: 4,
            boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
          }}
        >
          <Grid container spacing={4} alignItems="flex-start">
            <Grid item xs={12} md={8}>
              <MKTypography
                variant="h3"
                sx={{ fontWeight: 600, mb: 3, color: "#344767" }}
              >
                Challenges Before MedCo
              </MKTypography>
              <MKTypography
                variant="body1"
                sx={{
                  color: "#7b809a",
                  lineHeight: 1.8,
                  fontSize: "1.1rem",
                  mb: 3,
                }}
              >
                Before implementing MedCo, Elagi's operations were heavily
                fragmented, creating daily inefficiencies and unnecessary manual
                effort.
              </MKTypography>
              <MKTypography
                variant="h6"
                sx={{ fontWeight: 600, color: "#344767", mb: 2 }}
              >
                Key challenges included:
              </MKTypography>
              <Box
                component="ul"
                sx={{
                  color: "#7b809a",
                  lineHeight: 2,
                  pl: 3,
                  fontSize: "1.05rem",
                }}
              >
                <li>
                  Workflows spread across spreadsheets, paper schedules,
                  WhatsApp messages, and manual logs
                </li>
                <li>
                  No centralized system for managing appointments,
                  cancellations, or patient follow-ups
                </li>
                <li>
                  Limited visibility for managers into daily operations and
                  staff workload
                </li>
                <li>
                  Frequent schedule conflicts and occasional double bookings
                </li>
                <li>
                  Heavy reliance on receptionists to manually coordinate changes
                </li>
                <li>
                  Difficulty accessing patient history quickly during busy hours
                </li>
              </Box>
              <MKTypography
                variant="body1"
                sx={{
                  color: "#7b809a",
                  lineHeight: 1.8,
                  fontSize: "1.1rem",
                  mt: 3,
                }}
              >
                This lack of structure created operational chaos, slowed down
                decision-making, and made scaling the clinic increasingly
                difficult.
              </MKTypography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box
                component="img"
                src={M6}
                alt="MedCo challenges"
                sx={{
                  width: "100%",
                }}
              />
            </Grid>
          </Grid>
        </Card>

        {/* Why Elagi Chose MedCo */}
        <Card
          sx={{
            p: { xs: 3, md: 6 },
            mb: 4,
            borderRadius: 4,
            boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
          }}
        >
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={8}>
              <MKTypography
                variant="h3"
                sx={{ fontWeight: 600, mb: 3, color: "#344767" }}
              >
                Why Elagi Chose MedCo
              </MKTypography>
              <MKTypography
                variant="body1"
                sx={{
                  color: "#7b809a",
                  lineHeight: 1.8,
                  fontSize: "1.1rem",
                  mb: 3,
                }}
              >
                Elagi was not just looking for off-the-shelf software, they
                needed a system that could adapt to their real-world workflow
                and evolve as the clinic grew.
              </MKTypography>
              <MKTypography
                variant="h6"
                sx={{ fontWeight: 600, color: "#344767", mb: 2 }}
              >
                They chose MedCo for several key reasons:
              </MKTypography>
              <Box
                component="ul"
                sx={{
                  color: "#7b809a",
                  lineHeight: 2,
                  pl: 3,
                  fontSize: "1.05rem",
                }}
              >
                <li>
                  A centralized scheduling system tailored to clinic operations
                </li>
                <li>Cash flow and patient balance tracking</li>
                <li>
                  Automatic deduction of patient balances when taking sessions
                </li>
                <li>
                  A simple, intuitive interface suitable for reception staff
                </li>
                <li>Fast onboarding with minimal disruption</li>
                <li>Local support and rapid customization</li>
                <li>
                  Strong trust in The DevHouse team and their ability to iterate
                  based on feedback
                </li>
                <li>
                  Flexibility to evolve the software around Elagi's existing
                  processes
                </li>
              </Box>
              <MKTypography
                variant="body1"
                sx={{
                  color: "#7b809a",
                  lineHeight: 1.8,
                  fontSize: "1.1rem",
                  mt: 3,
                }}
              >
                This combination of usability, adaptability, and hands-on
                support made MedCo the right long-term partner.
              </MKTypography>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box
                component="img"
                src={M9}
                alt="Why Elagi chose MedCo"
                sx={{ width: "100%" }}
              />
            </Grid>
          </Grid>
        </Card>

        {/* The Solution */}
        <Card
          sx={{
            p: { xs: 3, md: 6 },
            mb: 4,
            borderRadius: 4,
            boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
          }}
        >
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={8}>
              <MKTypography
                variant="h3"
                sx={{ fontWeight: 600, mb: 3, color: "#344767" }}
              >
                The Solution: MedCo in Action
              </MKTypography>
              <MKTypography
                variant="body1"
                sx={{
                  color: "#7b809a",
                  lineHeight: 1.8,
                  fontSize: "1.1rem",
                  mb: 3,
                }}
              >
                MedCo delivered a centralized clinic management system designed
                to directly address Elagi's operational pain points.
              </MKTypography>
              <MKTypography
                variant="body1"
                sx={{
                  color: "#7b809a",
                  lineHeight: 1.8,
                  fontSize: "1.1rem",
                  mb: 3,
                }}
              >
                Previously, therapist schedules were managed on paper. Any
                update required manually changing each doctor's individual
                schedule, a slow and error-prone process. With MedCo, all
                schedules were centralized, meaning updates were reflected
                instantly across the system and visible to everyone involved.
              </MKTypography>
              <MKTypography
                variant="h6"
                sx={{ fontWeight: 600, color: "#344767", mb: 2 }}
              >
                Key capabilities delivered included:
              </MKTypography>
              <Box
                component="ul"
                sx={{
                  color: "#7b809a",
                  lineHeight: 2,
                  pl: 3,
                  fontSize: "1.05rem",
                }}
              >
                <li>
                  <strong>Smart Scheduling:</strong> A streamlined appointment
                  flow that reduced errors and conflicts
                </li>
                <li>
                  <strong>Centralized Patient Profiles:</strong> Instant access
                  to treatment history and visit records
                </li>
                <li>
                  <strong>Balance Tracking per Patient & Package:</strong> Every
                  patient and prepaid package maintains a live, accurate balance
                </li>
                <li>
                  <strong>Automatic Balance Deduction:</strong> Session usage is
                  deducted automatically, eliminating manual calculations
                </li>
                <li>
                  <strong>Reduced Accounting Work:</strong> Financial tracking
                  is handled by the system, minimizing human input and mistakes
                </li>
                <li>
                  <strong>Clear Financial History:</strong> All usage and
                  deductions are logged and traceable over time
                </li>
                <li>
                  <strong>Workflow Optimization:</strong> Faster daily handling
                  of appointments, check-ins, and updates
                </li>
                <li>
                  <strong>Role-Based Access:</strong> Clear separation between
                  receptionist and administrative responsibilities
                </li>
                <li>
                  <strong>WhatsApp Integration:</strong> One-tap communication
                  with patients for confirmations and updates
                </li>
              </Box>
              <MKTypography
                variant="body1"
                sx={{
                  color: "#7b809a",
                  lineHeight: 1.8,
                  fontSize: "1.1rem",
                  mt: 3,
                }}
              >
                The result was a cleaner, more responsive operation that
                supported both staff efficiency and patient experience.
              </MKTypography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box
                component="img"
                src={M3}
                alt="MedCo solution"
                sx={{
                  width: "100%",
                }}
              />
            </Grid>
          </Grid>
        </Card>

        {/* Implementation */}
        <Card
          sx={{
            p: { xs: 3, md: 6 },
            mb: 4,
            borderRadius: 4,
            boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
          }}
        >
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={8}>
              <MKTypography
                variant="h3"
                sx={{ fontWeight: 600, mb: 3, color: "#344767" }}
              >
                Implementation Approach
              </MKTypography>
              <MKTypography
                variant="body1"
                sx={{
                  color: "#7b809a",
                  lineHeight: 1.8,
                  fontSize: "1.1rem",
                  mb: 3,
                }}
              >
                The MedCo implementation followed a structured, collaborative
                process to ensure adoption and long-term success.
              </MKTypography>
              <MKTypography
                variant="h6"
                sx={{ fontWeight: 600, color: "#344767", mb: 2 }}
              >
                The process included:
              </MKTypography>
              <Box
                component="ul"
                sx={{
                  color: "#7b809a",
                  lineHeight: 2,
                  pl: 3,
                  fontSize: "1.05rem",
                }}
              >
                <li>
                  Requirements gathering to fully understand Elagi's workflows
                </li>
                <li>UI/UX design tailored to real clinic usage</li>
                <li>System configuration and development</li>
                <li>Testing to ensure stability and usability</li>
                <li>Training sessions for receptionists and administrators</li>
                <li>Ongoing support and close communication</li>
                <li>
                  Iterative improvements based on real operational feedback
                </li>
              </Box>
              <MKTypography
                variant="body1"
                sx={{
                  color: "#7b809a",
                  lineHeight: 1.8,
                  fontSize: "1.1rem",
                  mt: 3,
                }}
              >
                Responsibilities across departments were clearly defined,
                ensuring smoother coordination and accountability from day one.
              </MKTypography>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box
                component="img"
                src={M10}
                alt="Implementation approach"
                sx={{ width: "100%" }}
              />
            </Grid>
          </Grid>
        </Card>

        {/* Results */}
        <Card
          sx={{
            p: { xs: 3, md: 6 },
            mb: 4,
            borderRadius: 4,
            boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
          }}
        >
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={8}>
              <MKTypography
                variant="h3"
                sx={{ fontWeight: 600, mb: 3, color: "#344767" }}
              >
                Results After MedCo
              </MKTypography>
              <MKTypography
                variant="body1"
                sx={{
                  color: "#7b809a",
                  lineHeight: 1.8,
                  fontSize: "1.1rem",
                  mb: 3,
                }}
              >
                While specific metrics are confidential, the operational impact
                was clear and immediate.
              </MKTypography>
              <MKTypography
                variant="h6"
                sx={{ fontWeight: 600, color: "#344767", mb: 2 }}
              >
                Elagi experienced:
              </MKTypography>
              <Box
                component="ul"
                sx={{
                  color: "#7b809a",
                  lineHeight: 2,
                  pl: 3,
                  fontSize: "1.05rem",
                }}
              >
                <li>Drastically reduced manual coordination and paperwork</li>
                <li>Faster schedule changes and appointment handling</li>
                <li>Fewer errors and significantly fewer booking conflicts</li>
                <li>Automated financial tracking tied to patient usage</li>
                <li>
                  Consistent, accurate balance updates without manual
                  calculations
                </li>
                <li>
                  Clear visibility into patient payments, usage, and remaining
                  balances
                </li>
                <li>
                  Daily operational and financial reports generated
                  automatically
                </li>
                <li>
                  Reduced end-of-day reconciliation and manual reporting work
                </li>
                <li>Smoother, more predictable daily clinic operations</li>
                <li>Faster patient check-ins and check-outs</li>
                <li>
                  Less pressure and higher satisfaction among front-desk and
                  administrative staff
                </li>
                <li>Improved financial control and managerial oversight</li>
                <li>
                  Clear, real-time visibility across both operations and
                  finances
                </li>
                <li>
                  A workflow that scales cleanly without adding complexity or
                  headcount
                </li>
              </Box>
              <MKTypography
                variant="body1"
                sx={{
                  color: "#7b809a",
                  lineHeight: 1.8,
                  fontSize: "1.1rem",
                  mt: 3,
                }}
              >
                MedCo transformed daily operations from reactive problem-solving
                into structured, controlled execution.
              </MKTypography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box
                component="img"
                src={M4}
                alt="MedCo results"
                sx={{
                  width: "100%",
                }}
              />
            </Grid>
          </Grid>
        </Card>

        {/* Client Quote */}
        <Box
          sx={{
            p: { xs: 4, md: 6 },
            background: "linear-gradient(135deg, #667eea15, #764ba215)",
            borderRadius: 4,
            borderLeft: "6px solid #667eea",
            mb: 4,
            boxShadow: "0 4px 16px rgba(0,0,0,0.05)",
          }}
        >
          <MKTypography
            variant="h5"
            sx={{
              fontStyle: "italic",
              color: "#344767",
              lineHeight: 1.8,
              mb: 3,
              fontSize: { xs: "1.1rem", md: "1.3rem" },
            }}
          >
            "Before MedCo, operations and financial tracking required constant
            manual effort. Today, everything is centralized, usage is tracked
            automatically, and daily reports are always accurate. We finally
            have the operational confidence to scale."
          </MKTypography>
          <MKTypography
            variant="body1"
            sx={{ color: "#7b809a", fontWeight: 600 }}
          >
            — Clinic Management Team, Elagi
          </MKTypography>
        </Box>

        {/* Closing */}
        <Card
          sx={{
            p: { xs: 4, md: 6 },
            borderRadius: 4,
            background: "linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)",
            textAlign: "center",
            boxShadow: "0 8px 32px rgba(102, 126, 234, 0.4)",
          }}
        >
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={8}>
              <MKTypography
                variant="h4"
                color="white"
                sx={{
                  fontWeight: 600,
                  mb: 2,
                  textShadow: "1px 2px 4px rgba(0,0,0,0.2)",
                }}
              >
                Ready to Transform Your Clinic?
              </MKTypography>
              <MKTypography
                variant="body1"
                color="white"
                sx={{
                  lineHeight: 1.8,
                  fontSize: "1.1rem",
                  mb: 3,
                  opacity: 0.95,
                  textShadow: "1px 1px 2px rgba(0,0,0,0.1)",
                }}
              >
                MedCo is built for clinics that want to reduce operational
                chaos, streamline workflows, and centralize their entire
                operation into one clear system.
              </MKTypography>
              <MKButton
                variant="contained"
                onClick={() => setConsultOpen(true)}
                sx={{
                  px: 4,
                  py: 1.5,
                  fontSize: "1rem",
                  fontWeight: 700,
                  background: "linear-gradient(135deg,#0b1020 0%,#2b0057 100%)",
                  color: "#fff",
                  "&:hover": { boxShadow: "0 10px 30px rgba(43,0,87,0.45)" },
                }}
              >
                Talk to Us
              </MKButton>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box
                component="img"
                src={M5}
                alt="MedCo ready"
                sx={{
                  width: "100%",
                }}
              />
            </Grid>
          </Grid>
        </Card>
      </Container>

      {consultOpen && (
        <MKBox
          onClick={() => setConsultOpen(false)}
          sx={{
            position: "fixed",
            inset: 0,
            zIndex: 1300,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(0,0,0,0.5)",
            backdropFilter: "blur(3px)",
            overflow: "hidden",
            overscrollBehavior: "none",
            p: 2,
          }}
        >
          <Box
            onClick={(e) => e.stopPropagation()}
            sx={{
              width: { xs: "100%", md: "800px" },
              height: { xs: "75vh", md: "80vh" },
              position: "relative",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <ConsultationForm isModal onClose={() => setConsultOpen(false)} />
          </Box>
        </MKBox>
      )}

      <Footer />
    </MKBox>
  );
}

export default MedCoCaseStudy;
